__turbopack_context__.v({
  "badge": "count-badge-module__jjEF9G__badge",
});
